/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Coordinates of the victim in Cartesian space relative to the Sun
 * 
 * @export
 * @interface GetKillmailsKillmailIdKillmailHashPosition
 */
export interface GetKillmailsKillmailIdKillmailHashPosition {
    /**
     * x number
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashPosition
     */
    x: number;
    /**
     * y number
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashPosition
     */
    y: number;
    /**
     * z number
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashPosition
     */
    z: number;
}

/**
 * Check if a given object implements the GetKillmailsKillmailIdKillmailHashPosition interface.
 */
export function instanceOfGetKillmailsKillmailIdKillmailHashPosition(value: object): value is GetKillmailsKillmailIdKillmailHashPosition {
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('z' in value) || value['z'] === undefined) return false;
    return true;
}

export function GetKillmailsKillmailIdKillmailHashPositionFromJSON(json: any): GetKillmailsKillmailIdKillmailHashPosition {
    return GetKillmailsKillmailIdKillmailHashPositionFromJSONTyped(json, false);
}

export function GetKillmailsKillmailIdKillmailHashPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKillmailsKillmailIdKillmailHashPosition {
    if (json == null) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'z': json['z'],
    };
}

export function GetKillmailsKillmailIdKillmailHashPositionToJSON(json: any): GetKillmailsKillmailIdKillmailHashPosition {
    return GetKillmailsKillmailIdKillmailHashPositionToJSONTyped(json, false);
}

export function GetKillmailsKillmailIdKillmailHashPositionToJSONTyped(value?: GetKillmailsKillmailIdKillmailHashPosition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'x': value['x'],
        'y': value['y'],
        'z': value['z'],
    };
}

